import { OpcionValor } from "./opcion-valor.model";
import { Opcion } from "./opcion.model";
import { TablaDeEvaluacion } from "./tabla-de-evaluacion.model";

export class Sentencia
{
    id: number;
    nombre: string;
    descripcion: string;
    valor: Sentencia;
    valores: OpcionValor[];
    opcion: Opcion;
    level: number;
    expandable: boolean;
    editable: boolean;
    marcoNombre: string;
    enabled: boolean;
    sentencias: Sentencia[];
    tablaDeEvaluacion: TablaDeEvaluacion;
    esTextoLibre: boolean;
    cumpleNoCumple: boolean;
    adjuntos: string[];

    /**
     * Constructor
     *
     * @param sentencia
     */
    constructor(sentencia)
    {
        {
            this.id = sentencia.id || null;
            this.nombre = sentencia.nombre || '';
            this.descripcion = sentencia.descripcion || '';
            this.marcoNombre = sentencia.marcoNombre || "";
            this.enabled = sentencia.enabled || true;
            this.sentencias= sentencia.sentencias || [];
            this.adjuntos = sentencia.adjuntos || [];
            this.cumpleNoCumple = sentencia.cumpleNoCumple || false;
            this.tablaDeEvaluacion = sentencia.tablaDeEvaluacion;
            this.esTextoLibre = sentencia.esTextoLibre;
        }
    }
}
